/* eslint-disable */
import * as React from "react";
import {Button, Flex, Grid, PasswordField, TextField, CheckboxField, Text} from "@aws-amplify/ui-react";
import {getOverrideProps} from "@aws-amplify/ui-react/internal";
import {fetchByPath, validateField} from "./utils";

export default function MyForm(props) {
  const {onSubmit, onValidate, onChange, overrides, ...rest} = props;
  const {
    defaultToken = null,
    defaultEmail = null,
  } = rest || {}

  const initialValues = {
    given_name: "",
    family_name: "",
    email: defaultEmail,
    password: undefined,
    password_confirm: undefined,
    privacy_policy: false,
    advertising_policy: false,
    token: defaultToken,
  };

  const [given_name, setGiven_name] = React.useState(initialValues.given_name);
  const [family_name, setFamily_name] = React.useState(initialValues.family_name);
  const [email, setEmail] = React.useState(initialValues.email);
  const [password, setPassword] = React.useState(initialValues.password);
  const [password_confirm, setPassword_confirm] = React.useState(initialValues.password_confirm);
  const [privacy_policy, setPrivacy_policy] = React.useState(initialValues.privacy_policy);
  const [advertising_policy, setAdvertising_policy] = React.useState(initialValues.advertising_policy);
  const [token, setToken] = React.useState(initialValues.token);
  const [errors, setErrors] = React.useState({});

  // const resetStateValues = () => {
  //   setGiven_name(initialValues.given_name);
  //   setFamily_name(initialValues.family_name);
  //   setEmail(initialValues.email);
  //   setPassword(initialValues.password);
  //   setPassword_confirm(initialValues.password_confirm);
  //   setPrivacy_policy(initialValues.privacy_policy);
  //   setAdvertising_policy(initialValues.advertising_policy);
  //   setToken(initialValues.token);
  //   setErrors({});
  // };

  const validations = {
    given_name: [
      {type: "Required"},
    ],
    family_name: [
      {type: "Required"},
    ],
    email: [
      {type: "Required"},
      {type: "Email"}
    ],
    password: [
      {type: "Required"}
    ],
    password_confirm: [
      {type: "Required"},
    ],
    privacy_policy: [
      {type: "Required"},
    ],
    advertising_policy: [],
    token: [
      {type: "Required"}
    ]
  };

  const runValidationTasks = async (fieldName, currentValue, getDisplayValue) => {
    const value = currentValue && getDisplayValue ? getDisplayValue(currentValue) : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    // custom
    if (password && password_confirm && password !== password_confirm) {
      setErrors(errors => ({
        ...errors,
        password_confirm: {hasError: true, errorMessage: "Le due password non corrispondono"}
      }))
    } else {
      setErrors(errors => ({...errors, password_confirm: {hasError: false}}))
    }
    setErrors(errors => ({...errors, [fieldName]: validationResponse}));
    return validationResponse;
  };

  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="0px"
      onSubmit={async (event) => {
        event.preventDefault();
        const modelFields = {
          given_name,
          family_name,
          email,
          password,
          password_confirm,
          privacy_policy,
          advertising_policy,
          token
        };

        const validationResponses = await Promise.all(Object.keys(validations).reduce((promises, fieldName) => {
          if (Array.isArray(modelFields[fieldName])) {
            promises.push(...modelFields[fieldName].map(item => runValidationTasks(fieldName, item)));
            return promises;
          }
          promises.push(runValidationTasks(fieldName, modelFields[fieldName]));
          return promises;
        }, []));
        if (validationResponses.some(r => r.hasError)) {
          return;
        }
        await onSubmit(modelFields);
      }}
      {...getOverrideProps(overrides, "MyForm")} {...rest}
    >
      <TextField
        label="Nome"
        isRequired
        value={given_name}
        onChange={e => {
          let {value} = e.target;
          if (onChange) {
            const modelFields = {
              given_name: value,
              family_name,
              email,
              password,
              password_confirm,
              privacy_policy,
              advertising_policy,
              token
            };
            const result = onChange(modelFields);
            value = result?.given_name ?? value;
          }
          if (errors.given_name?.hasError) {
            runValidationTasks("given_name", value);
          }
          setGiven_name(value);
        }}
        onBlur={() => runValidationTasks("given_name", given_name)}
        errorMessage={errors.given_name?.errorMessage}
        hasError={errors.given_name?.hasError}
        {...getOverrideProps(overrides, "given_name")}
      />

      <TextField
        label="Cognome"
        isRequired
        value={family_name}
        onChange={e => {
          let {value} = e.target;
          if (onChange) {
            const modelFields = {
              given_name,
              family_name: value,
              email,
              password,
              password_confirm,
              privacy_policy,
              advertising_policy,
              token
            };
            const result = onChange(modelFields);
            value = result?.family_name ?? value;
          }
          if (errors.family_name?.hasError) {
            runValidationTasks("family_name", value);
          }
          setFamily_name(value);
        }}
        onBlur={() => runValidationTasks("family_name", family_name)}
        errorMessage={errors.family_name?.errorMessage}
        hasError={errors.family_name?.hasError}
        {...getOverrideProps(overrides, "family_name")}
      />

      <TextField
        label="E-mail"
        descriptiveText={
          <Text
            as="span"
            style={{
              color: 'var(--coaching-grey-50)',
              fontSize: '0.75rem !important',
              fontStyle: 'italic',
            }}
          >
            Inserisci la medesima e-mail alla quale hai ricevuto il link
          </Text>
        }
        isRequired
        value={email}
        onChange={e => {
          let {value} = e.target;
          if (onChange) {
            const modelFields = {
              given_name,
              family_name,
              email: value,
              password,
              password_confirm,
              privacy_policy,
              advertising_policy,
              token
            };
            const result = onChange(modelFields);
            value = result?.email ?? value;
          }
          if (errors.email?.hasError) {
            runValidationTasks("email", value);
          }
          setEmail(value);
        }}
        onBlur={() => runValidationTasks("email", email)} errorMessage={errors.email?.errorMessage}
        hasError={errors.email?.hasError} {...getOverrideProps(overrides, "email")}
      />

      <PasswordField
        label="Password"
        descriptiveText={
          <Text
            as="span"
            style={{
              color: 'var(--coaching-grey-50)',
              fontSize: '0.75rem !important',
              fontStyle: 'italic',
            }}
          >
            La password deve contenere minimo 8 caratteri di cui almeno una lettera maiuscola, una minuscola e un numero
          </Text>
        }
        isRequired
        onChange={e => {
          let {value} = e.target;
          if (onChange) {
            const modelFields = {
              given_name,
              family_name,
              email,
              password: value,
              password_confirm,
              privacy_policy,
              advertising_policy,
              token
            };
            const result = onChange(modelFields);
            value = result?.password ?? value;
          }
          if (errors.password?.hasError) {
            runValidationTasks("password", value);
          }
          setPassword(value);
        }}
        onBlur={() => runValidationTasks("password", password)}
        errorMessage={errors.password?.errorMessage}
        hasError={errors.password?.hasError}
        {...getOverrideProps(overrides, "password")}
      />

      <PasswordField
        label="Conferma password"
        isRequired
        onChange={e => {
          let {value} = e.target;
          if (onChange) {
            const modelFields = {
              given_name,
              family_name,
              email,
              password,
              password_confirm: value,
              privacy_policy,
              advertising_policy,
              token
            };
            const result = onChange(modelFields);
            value = result?.password_confirm ?? value;
          }
          if (errors.password_confirm?.hasError) {
            runValidationTasks("password_confirm", value);
          }
          setPassword_confirm(value);
        }}
        onBlur={() => runValidationTasks("password_confirm", password_confirm)}
        errorMessage={errors.password_confirm?.errorMessage}
        hasError={errors.password_confirm?.hasError}
        {...getOverrideProps(overrides, "password_confirm")}
      />

      <CheckboxField
        label={
          <>
            Ho preso visione dell’
            <a href="/privacy-policy-form-contatto" rel="noreferrer" target="_blank">
              Informativa Privacy
            </a>.
          </>
        }
        size="large"
        isRequired
        onChange={e => {
          let value = e.target.checked;

          if (onChange) {
            const modelFields = {
              given_name,
              family_name,
              email,
              password,
              password_confirm,
              privacy_policy: value,
              advertising_policy,
              token
            };
            const result = onChange(modelFields);
            value = result?.privacy_policy ?? value;
          }
          if (errors.privacy_policy?.hasError) {
            runValidationTasks("privacy_policy", value);
          }
          setPrivacy_policy(value);
        }}
        onBlur={() => runValidationTasks("privacy_policy", password_confirm)}
        errorMessage={errors.privacy_policy?.errorMessage}
        hasError={errors.privacy_policy?.hasError}
        {...getOverrideProps(overrides, "privacy_policy")}
      />

      <CheckboxField
        label='Acconsento a essere contattato da parte di FME Education S.p.A. attraverso i seguenti canali: email, posta cartacea, telefono/servizi di messaggistica per l’invio di materiale pubblicitario, comunicazioni commerciali inerenti i nostri servizi, informazioni sui corsi della nostra società, presentazioni o iniziative di P.R., di studi, di convegni, anche per il tramite di commerciali nonché di nostri agenti.'
        size="large"
        onChange={e => {
          let value = e.target.checked;

          if (onChange) {
            const modelFields = {
              given_name,
              family_name,
              email,
              password,
              password_confirm,
              privacy_policy,
              advertising_policy: value,
              token
            };
            const result = onChange(modelFields);
            value = result?.advertising_policy ?? value;
          }
          if (errors.advertising_policy?.hasError) {
            runValidationTasks("advertising_policy", value);
          }
          setAdvertising_policy(value);
        }}
        onBlur={() => runValidationTasks("advertising_policy", password_confirm)}
        errorMessage={errors.advertising_policy?.errorMessage}
        hasError={errors.advertising_policy?.hasError}
        {...getOverrideProps(overrides, "advertising_policy")}
      />

      <TextField
        label="Token"
        isRequired
        value={token}
        style={!!defaultToken ? {display: "none"} : {}}
        labelHidden={!!defaultToken}
        onChange={e => {
          let {value} = e.target;
          if (onChange) {
            const modelFields = {
              given_name,
              family_name,
              email,
              password,
              password_confirm,
              privacy_policy,
              advertising_policy,
              token: value
            };
            const result = onChange(modelFields);
            value = result?.token ?? value;
          }
          if (errors.token?.hasError) {
            runValidationTasks("token", value);
          }
          setToken(value);
        }}
        onBlur={() => runValidationTasks("token", token)}
        errorMessage={!!defaultToken ? null : errors.token?.errorMessage}
        hasError={!!defaultToken ? false : errors.token?.hasError}
        {...getOverrideProps(overrides, "token")}
      />

      <Flex>
        <Button
          style={{width: "100%"}}
          children="Registrati"
          type="submit"
          variation="primary"
          isDisabled={Object.values(errors).some(e => e?.hasError)}
          {...getOverrideProps(overrides, "SubmitButton")}/>
      </Flex>
    </Grid>
  );
}
